import React from "react";
import {PermissionGuard} from "../../components/PermissionGuard";
import {ContentManagementFeature} from "../../features/contentManagement";

const ALLOWED_PERMISSION = 'contentManagement'

const ContentManagementPage = ({
  userToken,
  userPermissions,
}) => (
  <PermissionGuard
    userToken={userToken}
    userPermissions={userPermissions}
    permissionKey={ALLOWED_PERMISSION}
  >
    <ContentManagementFeature
      userToken={userToken}
    />
  </PermissionGuard>
)

export default ContentManagementPage
